import React, { Component, Fragment } from "react";
import exitIcon from "../../images/nav/exit.svg";

export default class Modal extends Component {
  state = {
    name: "",
    email: "",
    phone: 0,
    message: "",
    investor: false,
    organization: false,
    athlete: false,
    other: false,
    redirect: false
  };

  handleName = e => this.setState({ name: e.target.value });
  handleEmail = e => this.setState({ email: e.target.value });
  handlePhone = e => this.setState({ phone: e.target.value ? Number(e.target.value) : 0 });
  handleType = e => {
    const { investor, organization, athlete, other } = this.state;
    const evt = e.target.name;
    this.setState({
      investor: evt === "investor" ? !investor : investor,
      organization: evt === "organization" ? !organization : organization,
      athlete: evt === "athlete" ? !athlete : athlete,
      other: evt === "other" ? !other : other
    });
  };
  handleMessage = e => this.setState({ message: e.target.value });
  
  

  render() {
    if (this.state.redirect === true) {
      setTimeout(() => {
        return (window.location.href = "/");
      }, 2000);
    }
    const style = this.props.display
      ? { display: "flex" }
      : { display: "none" };

    return (
      <Fragment>
        <div className="modal" style={style}>
          <div class="modal-content">
            <div className="modal-header">
              <h2 style={{ display: "inline-block" }}>Contact Us</h2>
              <img
                src={exitIcon}
                alt="exit icon for modal box"
                style={{
                  float: "right",
                  position: "relative",
                  width: "20px",
                  marginBottom: "15px"
                }}
                onClick={this.props.closeHandler}
              />
            </div>
            <form id="#myform" className="contact" action="4b5efb11fafa7f85209ea82b6ee9afa1" method="POST">
              <div className="contact-group">
                <label className="contact-label">Name</label>
                <br />
                <input
                  className="contact-input"
                  onChange={this.handleName}
                  type="text"
                  name="name"
                />
              </div>

              <div className="contact-group">
                <label className="contact-label">E-Mail</label>
                <br />
                <input
                  className="contact-input"
                  onChange={this.handleEmail}
                  type="email"
                  name="email"
                />
              </div>

              <div className="contact-group">
                <label className="contact-label">Phone Number</label>
                <br />
                <input
                  className="contact-input"
                  onChange={this.handlePhone}
                  type="tel"
                />
              </div>

              <div className="check">
                <label className="check-container">
                  <input
                    type="checkbox"
                    name="investor"
                    onChange={this.handleType}
                  />
                  <span className="check-title">Investor</span>
                </label>

                <label className="check-container">
                  <input
                    type="checkbox"
                    name="organization"
                    onChange={this.handleType}
                  />
                  <span className="check-title">Organization</span>
                </label>

                <label className="check-container">
                  <input
                    type="checkbox"
                    name="athlete"
                    onChange={this.handleType}
                  />
                  <span className="check-title">Athlete</span>
                </label>

                <label className="check-container">
                  <input
                    type="checkbox"
                    name="other"
                    onChange={this.handleType}
                  />
                  <span className="check-title">Other</span>
                </label>
              </div>

              <div className="contact-group">
                <label className="contact-label">Message</label>
                <br />
                <textarea 
                  onChange={this.handleMessage} 
                  type="text" 
                  placeholder="Enter your message here..." 
                  name="message"
                  data-sb-validations="required"
                />
              </div>
              <button className="btn" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}
